module.exports = __webpack_public_path__ + "57bb8282274d3384200e29b95f56b43b.jpg";